import React from 'react';
import { Pagination } from '../../../common-components/Pagination/Pagination';
import { WaitingIcon } from '../../../common-components/WaitingIcon/WaitingIcon';
import { DnpLink } from '../../../models/DnpLink';
import { strings } from '../../../resources/strings';
import { DnpLinks } from '../DnpLinks/DnpLinks';
import { Container } from './styles';

interface IPaginatedDnpLinksListProps {
    currentPage: number;
    currentPageSize: number;
    amountOfPages: number;
    totalAmount: number;
    dnpLinks?: DnpLink[];
    filterAreaHeight: number;
    pageSize: number;
    changePageSize: (pageSize: number) => void;
    changePage: (page: number) => void;
    filtering?: boolean;
}

const PaginatedDnpLinksList: React.FC<IPaginatedDnpLinksListProps> = ({
    currentPage,
    currentPageSize,
    amountOfPages,
    totalAmount,
    dnpLinks,
    filterAreaHeight,
    pageSize,
    changePageSize,
    changePage,
    filtering
}) => {

    if (filtering) return <WaitingIcon />;

    return (
        <Container>
            {dnpLinks && dnpLinks.length > 0 ?
            <DnpLinks 
                dnpLinks={dnpLinks}
                filterAreaHeight={filterAreaHeight}
            />
            : null }
            <Pagination
                currentPage={currentPage}
                currentPageSize={currentPageSize}
                amountOfPages={amountOfPages}
                totalAmount={totalAmount}
                pageSize={pageSize}
                changePageSize={(size) => changePageSize(size)}
                changePage={(page) => changePage(page)}
                descriptionForNoneRecordFound={strings.NoneRecordFound}
                hidePageSizeOptions={true}
            />
        </Container>
    );
}

export {PaginatedDnpLinksList};